var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tx-window',{ref:"window",attrs:{"title":_vm.$t('wrapStation')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var onTxStatus = ref.onTxStatus;
return [_c('wrap-station-form',{attrs:{"wallet-address":_vm.walletAddress},on:{"transaction-status":function($event){return onTxStatus($event)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }